export default __webpack_public_path__ + "static/media/rbsoul.641204c6.png";